<template>
  <v-dialog v-model="dialog" persistent max-width="30%">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar class="toolbar-color">
          <span class="headline ml-2">
            {{ labelBtn != "Salvar" ? "Editar Menu" : "Cadastrar Menu" }}
          </span>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Menu"
                v-model="form.descricao"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <BaseSelect
                clearable
                single-line
                label="Módulo"
                item-text="modulo"
                item-value="id_modulo"
                service="sistemaService.modulos"
                v-model="form.id_modulo"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">Fechar</v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="labelBtn != 'Salvar' ? editarMenu() : cadastrarMenu()"
          >{{ labelBtn }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import sistema from "@/services/http/sistemaService";
import rules from "@/mixins/inputRules";
import BaseSelect from "@/components/shared/BaseSelectService";
export default {
  name: "ModalCadMenu",

  mixins: [rules],

  props: {
    dialog: {
      type: Boolean
    },

    labelBtn: {
      type: String
    },

    editMenu: {
      type: Object
    }
  },

  components: {
    BaseSelect
  },

  data() {
    return {
      form: {}
    };
  },

  watch: {
    editMenu(value) {
      this.form = value;
    }
  },

  methods: {
    async cadastrarMenu() {
      const validateStatus = this.$refs.form.validate();

      if (validateStatus) {
        await sistema()
          .menus()
          .store(this.form, {
            notification: true,
            message: "Menu cadastrado com sucesso!"
          });
        this.close();
      }
    },

    async editarMenu() {
      const validateStatus = this.$refs.form.validate();

      if (validateStatus) {
        await sistema()
          .menus(this.form.id)
          .update(this.form, {
            notification: true,
            message: "Menu editado com sucesso!"
          });
        this.close();
      }
    },

    close() {
      this.$emit("close");
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
